import { CircularProgress } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  getBookingQuestions,
  invokeQuestionRecommenderWebhook,
} from '../../../services/apiService';

export default function SessionQuestionsPopup({ booking, close }) {
  const [bookingQuestions, setBookingQuestions] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const response = await getBookingQuestions(booking.id);
        setBookingQuestions(response);
      } catch (err) {
        console.error(err);
      }
    };
    fetchQuestions();
  }, []);

  const handleRegenerateQuestions = async () => {
    setIsLoading(true);
    try {
      await invokeQuestionRecommenderWebhook({
        bookingId: booking.id,
        subTopic: {
          id: booking.subTopicId,
          name: booking.subTopicName,
        },
        student: _.pick(booking.Student, ['id', 'email']),
        retriggered: true,
      });
      toast.success('Questions regenerated successfully');
      close();
    } catch (err) {
      console.error(err);
      toast.error('Failed to regenerate questions');
    }
    setIsLoading(false);
  };

  return (
    <div className='fixed inset-0 bg-black bg-opacity-80 flex'>
      <div className='m-auto w-full max-w-2xl max-h-screen overflow-scroll bg-white rounded p-5 relative'>
        <h6 className='text-xl font-semibold opacity-80 px-1'>
          Session Questions
        </h6>
        <button onClick={close} className='absolute top-4 right-4 opacity-60'>
          <Close />
        </button>

        {bookingQuestions ? (
          <>
            <ol className='list-decimal list-outside px-5 mt-4'>
              {bookingQuestions.map((bq) => (
                <li className='mt-4' key={bq.id}>
                  <span>{bq?.Question?.question}</span>
                  <p className='text-sm opacity-60'>
                    <span>Difficulty Level: </span>
                    <span className='font-medium capitalize inline-block w-36'>
                      {bq?.Question?.difficultyLevel}
                    </span>
                  </p>
                </li>
              ))}
            </ol>

            <div className='text-right'>
              <button
                onClick={handleRegenerateQuestions}
                className='bg-blue-c1 text-white rounded px-4 py-1 mt-4'
              >
                {isLoading ? (
                  <span className='px-20 flex'>
                    <CircularProgress color='inherit' size='1.5rem' />
                  </span>
                ) : (
                  <span>Regenerate Questions</span>
                )}
              </button>
            </div>
          </>
        ) : (
          <div className='text-blue-c1 text-center my-6'>
            <CircularProgress color='inherit' />
          </div>
        )}
      </div>
    </div>
  );
}
